import { shuffle, reverse } from 'lodash';
import { Collection, ObjectCollection } from '../app';
import { buildResource, clone } from './misc.helper';
/**
 * Transform a given array of Resource into Collection
 * @param list
 * @param cls
 * @returns Collection<T>
 */
export function collect(cls, list) {
    var collection = new Collection(cls);
    if (list) {
        collection.items = list;
    }
    return collection;
}
/**
 * Transform a given array of Resource Object into Collection
 * @param list
 * @param i18nPath
 * @returns ObjectCollection
 */
export function objectCollect(list, i18nPath) {
    return new ObjectCollection(list, i18nPath);
}
/**
 * Prepends a empty value into the resource list
 * @param list
 * @param placeholder
 */
export function nullableItems(list, placeholder) {
    if (placeholder === void 0) { placeholder = null; }
    var item = null;
    if (typeof placeholder === 'string')
        item = buildResource(0, placeholder);
    var items = clone(list);
    items.splice(0, 0, item);
    return items;
}
/**
 * Get Resource by ID
 * @param list
 * @param id
 */
export function getResource(list, id) {
    return clone(list).find(function (item) { return item.$id === id; }) || null;
}
/**
 * Filter Resource by IDs
 * @param list
 * @param ids
 */
export function getManyResource(list, ids) {
    return clone(list).filter(function (item) { return ids.find(function (id) { return item.$id === id; }); });
}
/**
 * Get the first item of the list
 * @param list
 */
export function firstResource(list) {
    return list[0] || null;
}
/**
 * Get the last item of the list
 * @param list
 */
export function lastResource(list) {
    return list[list.length - 1] || null;
}
/**
 * Add an item into the begin of the list
 * @param list
 * @param item
 */
export function prependResource(list, item) {
    addResource(list, item, 0);
    return list;
}
/**
 * Add an item into the end of the list
 * @param list
 * @param item
 */
export function appendResource(list, item) {
    addResource(list, item);
    return list;
}
/**
 * Shuffle a list of Resource
 * @param list
 */
export function shuffleResource(list) {
    list = shuffle(list);
    return list;
}
/**
 * Reverse a list of Resource
 * @param list
 */
export function reverseResource(list) {
    list = reverse(list);
    return list;
}
/**
 * Add a Resource
 * @param list
 * @param item
 * @param index
 */
export function addResource(list, item, index) {
    if (index !== undefined) {
        list.splice(index, 0, item);
    }
    else {
        list.push(item);
    }
}
/**
 * Remove a Resource by ID
 * @param list
 * @param id
 */
export function removeResource(list, id) {
    var index = clone(list).findIndex(function (item) { return item.$id === id; });
    if (index) {
        list.splice(index, 1);
    }
}
//# sourceMappingURL=collection.helper.js.map